"use strict";

var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _uuid = _interopRequireDefault(require("uuid"));
var _constants = require("../constants");
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
var MembersUtil = {
  /**
   * @param {Object} invitee with emailAddress, email or phoneNumber
   * @param {String} locusUrl
   * @param {Boolean} alertIfActive
   * @returns {Object} the format object
   */
  generateAddMemberOptions: function generateAddMemberOptions(invitee, locusUrl, alertIfActive) {
    return {
      invitee: invitee,
      locusUrl: locusUrl,
      alertIfActive: alertIfActive
    };
  },
  /**
   * @param {Array} memberIds
   * @param {String} locusUrl
   * @returns {Object} the format object
   */
  generateAdmitMemberOptions: function generateAdmitMemberOptions(memberIds, locusUrl) {
    return {
      locusUrl: locusUrl,
      memberIds: memberIds
    };
  },
  /**
   * @param {Object} options with {invitee: {emailAddress, email, phoneNumber}, alertIfActive}
   * @returns {Object} with {invitees: [{address}], alertIfActive}
   */
  getAddMemberBody: function getAddMemberBody(options) {
    return {
      invitees: [_objectSpread({
        address: options.invitee.emailAddress || options.invitee.email || options.invitee.phoneNumber
      }, options.invitee.roles ? {
        roles: options.invitee.roles
      } : {})],
      alertIfActive: options.alertIfActive
    };
  },
  /**
   * @param {Object} options with {memberIds, authorizingLocusUrl}
   * @returns {Object} admit with {memberIds}
   */
  getAdmitMemberRequestBody: function getAdmitMemberRequestBody(options) {
    var memberIds = options.memberIds,
      sessionLocusUrls = options.sessionLocusUrls;
    var body = {
      admit: {
        participantIds: memberIds
      }
    };
    if (sessionLocusUrls) {
      var authorizingLocusUrl = sessionLocusUrls.authorizingLocusUrl;
      return _objectSpread({
        authorizingLocusUrl: authorizingLocusUrl
      }, body);
    }
    return body;
  },
  /**
   * @param {Object} format with {memberIds, locusUrl, sessionLocusUrls}
   * @returns {Object} the request parameters (method, uri, body) needed to make a admitMember request
   * if a host/cohost is in a breakout session, the locus url should be the main session locus url
   */
  getAdmitMemberRequestParams: function getAdmitMemberRequestParams(format) {
    var body = MembersUtil.getAdmitMemberRequestBody(format);
    var locusUrl = format.locusUrl,
      sessionLocusUrls = format.sessionLocusUrls;
    var baseUrl = (sessionLocusUrls === null || sessionLocusUrls === void 0 ? void 0 : sessionLocusUrls.mainLocusUrl) || locusUrl;
    var uri = "".concat(baseUrl, "/").concat(_constants.CONTROLS);
    return {
      method: _constants.HTTP_VERBS.PUT,
      uri: uri,
      body: body
    };
  },
  /**
   * @param {Object} format with {invitee {emailAddress, email, phoneNumber}, locusUrl, alertIfActive}
   * @returns {Object} the request parameters (method, uri, body) needed to make a addMember request
   */
  getAddMemberRequestParams: function getAddMemberRequestParams(format) {
    var body = MembersUtil.getAddMemberBody(format);
    var requestParams = {
      method: _constants.HTTP_VERBS.PUT,
      uri: format.locusUrl,
      body: body
    };
    return requestParams;
  },
  isInvalidInvitee: function isInvalidInvitee(invitee) {
    if (!(invitee && (invitee.email || invitee.emailAddress || invitee.phoneNumber))) {
      return true;
    }
    if (invitee.phoneNumber) {
      return !_constants.DIALER_REGEX.E164_FORMAT.test(invitee.phoneNumber);
    }
    return !_constants.VALID_EMAIL_ADDRESS.test(invitee.email || invitee.emailAddress);
  },
  getRemoveMemberRequestParams: function getRemoveMemberRequestParams(options) {
    var body = {
      reason: options.reason
    };
    var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.LEAVE);
    return {
      method: _constants.HTTP_VERBS.PUT,
      uri: uri,
      body: body
    };
  },
  generateTransferHostMemberOptions: function generateTransferHostMemberOptions(transfer, moderator, locusUrl) {
    return {
      moderator: moderator,
      locusUrl: locusUrl,
      memberId: transfer
    };
  },
  generateRemoveMemberOptions: function generateRemoveMemberOptions(removal, locusUrl) {
    return {
      reason: _constants._FORCED_,
      memberId: removal,
      locusUrl: locusUrl
    };
  },
  generateMuteMemberOptions: function generateMuteMemberOptions(memberId, status, locusUrl, isAudio) {
    return {
      memberId: memberId,
      muted: status,
      locusUrl: locusUrl,
      isAudio: isAudio
    };
  },
  generateRaiseHandMemberOptions: function generateRaiseHandMemberOptions(memberId, status, locusUrl) {
    return {
      memberId: memberId,
      raised: status,
      locusUrl: locusUrl
    };
  },
  /**
   * @param {String} memberId
   * @param {[ServerRoleShape]} roles
   * @param {String} locusUrl
   * @returns {RoleAssignmentOptions}
   */
  generateRoleAssignmentMemberOptions: function generateRoleAssignmentMemberOptions(memberId, roles, locusUrl) {
    return {
      memberId: memberId,
      roles: roles,
      locusUrl: locusUrl
    };
  },
  generateLowerAllHandsMemberOptions: function generateLowerAllHandsMemberOptions(requestingParticipantId, locusUrl, roles) {
    return _objectSpread({
      requestingParticipantId: requestingParticipantId,
      locusUrl: locusUrl
    }, roles !== undefined && {
      roles: roles
    });
  },
  /**
   * @param {String} memberId id of the participant who is receiving request
   * @param {String} requestingParticipantId id of the participant who is sending request (optional)
   * @param {String} alias alias name
   * @param {String} locusUrl url
   * @returns {Object} consists of {memberID: string, requestingParticipantId: string, alias: string, locusUrl: string}
   */
  generateEditDisplayNameMemberOptions: function generateEditDisplayNameMemberOptions(memberId, requestingParticipantId, alias, locusUrl) {
    return {
      memberId: memberId,
      requestingParticipantId: requestingParticipantId,
      alias: alias,
      locusUrl: locusUrl
    };
  },
  getMuteMemberRequestParams: function getMuteMemberRequestParams(options) {
    var property = options.isAudio === false ? 'video' : 'audio';
    var body = (0, _defineProperty2.default)({}, property, {
      muted: options.muted
    });
    var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.CONTROLS);
    return {
      method: _constants.HTTP_VERBS.PATCH,
      uri: uri,
      body: body
    };
  },
  /**
   * @param {ServerRoleShape} role
   * @returns {ServerRoleShape} the role shape to be added to the body
   */
  getAddedRoleShape: function getAddedRoleShape(role) {
    var roleShape = {
      type: role.type,
      hasRole: role.hasRole
    };
    if (role.hostKey) {
      roleShape.hostKey = role.hostKey;
    }
    return roleShape;
  },
  /**
   * @param {RoleAssignmentOptions} options
   * @returns {RoleAssignmentRequest} the request parameters (method, uri, body) needed to make a addMember request
   */
  getRoleAssignmentMemberRequestParams: function getRoleAssignmentMemberRequestParams(options) {
    var body = {
      role: {
        roles: []
      }
    };
    options.roles.forEach(function (role) {
      body.role.roles.push(MembersUtil.getAddedRoleShape(role));
    });
    var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.CONTROLS);
    return {
      method: _constants.HTTP_VERBS.PATCH,
      uri: uri,
      body: body
    };
  },
  getRaiseHandMemberRequestParams: function getRaiseHandMemberRequestParams(options) {
    var body = {
      hand: {
        raised: options.raised
      }
    };
    var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.CONTROLS);
    return {
      method: _constants.HTTP_VERBS.PATCH,
      uri: uri,
      body: body
    };
  },
  getLowerAllHandsMemberRequestParams: function getLowerAllHandsMemberRequestParams(options) {
    var body = {
      hand: _objectSpread({
        raised: false
      }, options.roles !== undefined && {
        roles: options.roles
      }),
      requestingParticipantId: options.requestingParticipantId
    };
    var uri = "".concat(options.locusUrl, "/").concat(_constants.CONTROLS);
    return {
      method: _constants.HTTP_VERBS.PATCH,
      uri: uri,
      body: body
    };
  },
  /**
   * @param {Object} options with format of {locusUrl: string, requestingParticipantId: string}
   * @returns {Object} request parameters (method, uri, body) needed to make a editDisplayName request
   */
  editDisplayNameMemberRequestParams: function editDisplayNameMemberRequestParams(options) {
    var body = {
      aliasValue: options.alias,
      requestingParticipantId: options.requestingParticipantId
    };
    var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.ALIAS);
    return {
      method: _constants.HTTP_VERBS.POST,
      uri: uri,
      body: body
    };
  },
  getTransferHostToMemberRequestParams: function getTransferHostToMemberRequestParams(options) {
    var body = {
      role: {
        moderator: options.moderator
      }
    };
    var uri = "".concat(options.locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(options.memberId, "/").concat(_constants.CONTROLS);
    return {
      method: _constants.HTTP_VERBS.PATCH,
      uri: uri,
      body: body
    };
  },
  genderateSendDTMFOptions: function genderateSendDTMFOptions(url, tones, memberId, locusUrl) {
    return {
      url: url,
      tones: tones,
      memberId: memberId,
      locusUrl: locusUrl
    };
  },
  generateSendDTMFRequestParams: function generateSendDTMFRequestParams(_ref) {
    var url = _ref.url,
      tones = _ref.tones,
      memberId = _ref.memberId,
      locusUrl = _ref.locusUrl;
    var body = {
      device: {
        url: url
      },
      memberId: memberId,
      dtmf: {
        correlationId: _uuid.default.v4(),
        tones: tones,
        direction: 'transmit'
      }
    };
    var uri = "".concat(locusUrl, "/").concat(_constants.PARTICIPANT, "/").concat(memberId, "/").concat(_constants.SEND_DTMF_ENDPOINT);
    return {
      method: _constants.HTTP_VERBS.POST,
      uri: uri,
      body: body
    };
  },
  cancelPhoneInviteOptions: function cancelPhoneInviteOptions(invitee, locusUrl) {
    return {
      invitee: invitee,
      locusUrl: locusUrl
    };
  },
  generateCancelInviteRequestParams: function generateCancelInviteRequestParams(options) {
    var body = {
      actionType: _constants._REMOVE_,
      invitees: [{
        address: options.invitee.phoneNumber
      }]
    };
    var requestParams = {
      method: _constants.HTTP_VERBS.PUT,
      uri: options.locusUrl,
      body: body
    };
    return requestParams;
  }
};
var _default = exports.default = MembersUtil;
//# sourceMappingURL=util.js.map
